/**
 * Challenge card – picks card container, match grid, team rows, and bet rows.
 * Composed by challengeCardMatches.styles.ts.
 */

import { Platform } from 'react-native';
import { makeBoxShadow } from '../../shared/helpers/shadowStyles.helper';
import type { Theme } from '../../theme/getTheme';

export function getChallengeCardMatchGridStyles(theme: Theme): Record<string, object> {
  return {
    picksCard: {
      marginBottom: 14,
      paddingVertical: 14,
      paddingHorizontal: 16,
      backgroundColor: theme.background.card,
      borderRadius: 12,
      borderWidth: 1,
      borderColor: theme.gray[400],
      ...(Platform.OS === 'web'
        ? makeBoxShadow({
            shadowColor: theme.primary,
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.04,
            shadowRadius: 2,
          })
        : {
            shadowColor: theme.primary,
            shadowOffset: { width: 0, height: 1 },
            shadowOpacity: 0.04,
            shadowRadius: 2,
            elevation: 1,
          }),
    },
    matchBetGrid: {
      flexDirection: 'row',
      alignItems: 'stretch',
      alignSelf: 'stretch',
      width: '100%',
      gap: 0,
    },
    matchBetCol: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: 8,
    },
    matchBetColSide: {
      width: 72,
      minWidth: 72,
    },
    matchBetColSideWide: {
      width: 88,
      minWidth: 88,
    },
    matchBetColCenter: {
      flex: 1,
      minWidth: 52,
    },
    matchBetMatchCell: {
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 64,
    },
    matchBetBetCell: {
      alignSelf: 'stretch',
      width: '100%',
      minHeight: 56,
      justifyContent: 'center',
      alignItems: 'center',
    },
    matchTeamsRow: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'stretch',
      width: '100%',
      marginBottom: 12,
      gap: 0,
    },
    matchTeamBlockSide: {
      flex: 1,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    matchTeamBlockSideLeft: {
      justifyContent: 'flex-end',
    },
    matchTeamBlockSideRight: {
      justifyContent: 'flex-start',
    },
    matchTeamsCenter: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: 52,
      maxWidth: 80,
    },
    matchTeamsCenterDate: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[600],
      textAlign: 'center',
    },
    matchTeamsCenterTime: {
      fontSize: 11,
      fontWeight: '500',
      color: theme.gray[600],
      textAlign: 'center',
      marginTop: 2,
    },
    matchTeamsCenterLiveCaption: {
      fontSize: 11,
      fontWeight: '700',
      color: theme.error,
      textAlign: 'center',
      marginTop: 4,
      letterSpacing: 0.6,
    },
    matchTeamDot: {
      width: 8,
      height: 8,
      borderRadius: 4,
      backgroundColor: theme.error,
    },
    matchTeamDotAway: {
      backgroundColor: theme.primary,
    },
    matchTeamName: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.black,
      textAlign: 'center',
    },
    matchScoreText: {
      fontSize: 22,
      fontWeight: '800',
      color: theme.success,
      minWidth: 48,
      textAlign: 'center',
    },
    matchScoreTextLive: {
      color: theme.error,
    },
    marketRowsContainer: {
      marginTop: 10,
    },
    betRow: {
      flexDirection: 'row',
      alignItems: 'stretch',
      alignSelf: 'stretch',
      width: '100%',
      marginBottom: 10,
      gap: 0,
      minHeight: 56,
    },
    betRowMarketName: {
      flex: 1,
      justifyContent: 'center',
      paddingHorizontal: 12,
      paddingVertical: 10,
      backgroundColor: theme.background.card,
      borderLeftWidth: 1,
      borderRightWidth: 1,
      borderColor: theme.gray[300],
    },
    betRowMarketNameText: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[600],
      textAlign: 'center',
    },
    betRowCorrectOutcomeRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 2,
      gap: 4,
    },
    betRowCorrectOutcome: {
      fontSize: 10,
      fontWeight: '500',
      color: theme.gray[500],
      textAlign: 'center',
    },
  };
}
